import { XcoreError } from "./XcoreError";

export class InsertInquiryError extends XcoreError {
  public name: "InsertInquiryError" = "InsertInquiryError" as const;

  public response: Response;

  public errors: Record<string, string[]>;

  public serverError?: string;

  constructor(url: string, res: Response, errors?: Record<string, string[]>, serverError?: string) {
    super(url, "Unable to insert inquiry");
    this.response = res;
    this.errors = errors ?? {};
    this.serverError = serverError;
  }
}
